import { render } from "./NotificationsFilters.vue?vue&type=template&id=041f4002&scoped=true&ts=true"
import script from "./NotificationsFilters.vue?vue&type=script&lang=ts"
export * from "./NotificationsFilters.vue?vue&type=script&lang=ts"

import "./NotificationsFilters.vue?vue&type=style&index=0&id=041f4002&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041f4002"]])

export default __exports__